export default [
    {
        name: 'Contratos',
        url: '/gescon/gerentes/contratos',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-GER-CONT-00',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        }
    },
    {
        name: 'Requisições',
        url: '/gescon/gerentes/requisicoes',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-GER-REQ-00',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        }
    },
    {
        name: 'Pagamentos',
        url: '/gescon/gerentes/pagamentos',
        icon: 'fa fa-dollar',
        regras: 'GESCON-GER-PAG-00',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        }
    }
]
